import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "truncate",
    standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(
    text: string,
    length: number = null,
    suffix: string = "..."
  ) {
    if (length && text.length > length) {
      const truncated = text.substring(0, length).trim();
      const lastIndex = truncated.substring(0, truncated.lastIndexOf(" "));
        
      return lastIndex + suffix;
    }

    return text;
  }
}
